import { useState } from "react"
import { v4 as uuid } from "uuid"

/* Generates a unique id for a component's lifecycle.
 * Useful when 2 instances of a component need to be uniquely identified,
 * e.g. so form ids don't conflict if 2 of the same form exist
 */
export const useComponentId = () => {
  const [id] = useState(uuid())
  return id
}
